import * as React from "react";
import { forwardRef } from "react";
const SvgLeftArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 12, viewBox: "0 0 8 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6.3252 11.7751L7.4502 10.7251L2.72519 6.0001L7.4502 1.2751L6.3252 0.225098L0.550194 6.0001L6.3252 11.7751Z", fill: "#111111" }));
const ForwardRef = forwardRef(SvgLeftArrow);
export default ForwardRef;
